export const sanitizeMarkdown = (mkdwn?: string | null): string => {
    if (!mkdwn) return ''

    return (
        mkdwn
            // Replace escaped newlines with actual newlines
            .replace(/\\n/g, '\n')
            /**
             * react-markdown does not render a single newline on a new line.
             * For presentational purposes only, we replace single newlines with double newlines
             * to ensure they're rendered on a new line.
             */
            .replace(/(?<!\n)\n(?!\n)/g, '\n\n')
    )
}
